/** @format */
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProductSelectionState } from '@pdp/data-access/interfaces';

const selectProductionSelectionState =
	createFeatureSelector<ProductSelectionState>('productSelection');

export const selectAllKillswitches = createSelector(
	selectProductionSelectionState,
	(state) => state.killswitches
);

export const selectKillswitch = (killswitchName: string) =>
	createSelector(selectAllKillswitches, (state) => state[killswitchName] ?? false);
